import { combineReducers } from 'redux';
import register from './registerReducer';
import login from './loginReducer';
import dsdangcho from './getDSDangChoReducer';
import dshoantat from './getDSHoanTatReducer';
import chitietcls from './getChiTietCLSReducer';
import savedatacls from './saveDataCLSReducer';

const rootReducer = combineReducers({
  register, login, dsdangcho, chitietcls, savedatacls, dshoantat
});

export default rootReducer;